import { useMemo } from 'react';
import { useNoiseEventClassificationCategories } from './useNoiseEventClassificationCategories';
import { useNoiseEventClassifications } from './useNoiseEventClassifications';

export const useNoiseClassificationsListingData = () => {
  const { categories: allCategories, isFetching: isFetchingCategories } = useNoiseEventClassificationCategories();
  const { data, isFetching: isFetchingClassifications } = useNoiseEventClassifications();
  const categories = useMemo(() => {
    if (!allCategories || !data) return [];
    return allCategories.filter(cat => data.some(c => c.categoryId === cat.id));
  }, [allCategories, data]);

  return useMemo(() => {
    return {
      classifications: data ?? [],
      categories,
      isFetching: isFetchingCategories || isFetchingClassifications,
    };
  }, [data, isFetchingCategories, isFetchingClassifications, categories]);
};
